<div [id]="id" class="dropdown search-dropdown">
  <button
    #dropdownButton
    class="btn button-common"
    [ngClass]="{'button-regular': !alternateLook, 'button-alternate': alternateLook}"
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
    [disabled]="items.length === 0"
    [ngStyle]="{'border-radius': borderRadius}"
  >
    <span class="value-text" *ngIf="!selectedItem">{{label! | translate}}</span>
    <span class="value-text" *ngIf="selectedItem">{{selectedItem.name}}</span>
    <div class="arrow-box">
        <img src="../../../assets/icons/ng_v3/dropdown-icon.svg" alt="dropdown icon" />
    </div>
  </button>

  <ul class="dropdown-menu">
    <div *ngIf="searchEnabled" class="search-input modal-dropdown-select-input">
      <img src="../../assets/icons/search.svg" alt="Search icon"/>
      <input
        type="text"
        placeholder="{{ 'COMMON.SEARCH' | translate }}"
        [(ngModel)]="searchValue"
        (input)="applySearchFilter()"
      />
    </div>

    <div class="dropdown-items">
      <div
        [id]="id + '_item-' + (i + 1)"
        *ngFor="let item of filteredItems; let i = index"
         [ngClass]="{'dropdown-item': true, 'selected': selectedItem && item.id === selectedItem.id}"
        (click)="selectItem(item)"
        click-stop-propagation
      >
        <span>{{item.name}}</span>
      </div>
    </div>
  </ul>
</div>